import { useRef, useEffect, useState } from "react";
import { Image, Transformer } from "react-konva";
import {
  DraggableItem,
  DraggableItemObj,
  RenderElProps,
} from "./draggable-item.class";
import {
  DeleteButton,
  MirrorButton,
  DuplicateElButton,
  MoveUpperButton,
  MoveLowerButton,
} from "../components/draggable-menu-btns";
import { Html } from "react-konva-utils";
import { ItemMenuContainer } from "./comic.class";

export class Scenario extends DraggableItem {
  protected menuButtons = [
    DeleteButton,
    MirrorButton,
    DuplicateElButton,
    MoveUpperButton,
    MoveLowerButton,
  ];

  constructor(obj: Omit<DraggableItemObj, "type">, imgUrl: string) {
    super({ ...obj, type: "scenarios" }, imgUrl);
  }

  render(props: RenderElProps): JSX.Element {
    const El = () => {
      const shapeRef: React.MutableRefObject<any> = useRef();
      const trRef: React.MutableRefObject<any> = useRef();
      const itemMenuRef = useRef<HTMLDivElement>(null);

      const [itemMenuEl, setItemMenuEl] = useState<HTMLDivElement | null>(null);

      useEffect(() => {
        this.imageRef = shapeRef.current;
        setItemMenuEl(itemMenuRef.current);

        if (props.isSelected) {
          // we need to attach transformer manually
          trRef.current.nodes([shapeRef.current]);
          trRef.current.getLayer().batchDraw();
        }
      }, []);

      const scaleX = props.scaleX ?? 1;
      const scaleY = props.scaleY ?? 1;
      return (
        <>
          <Image
            ref={shapeRef}
            draggable={props.isSelected}
            image={this.getImage()}
            x={this.x * scaleX}
            y={this.y * scaleY}
            width={this.width * scaleX}
            height={this.height * scaleY}
            rotation={this.rotation}
            onClick={props.onClick}
            onDragMove={(e) => props.onDragMove(e, itemMenuRef.current)}
            onDragEnd={props.onDragEnd}
            onTouchStart={(e) => this.onTouchStart(e)}
            onTouchEnd={(e) => this.onTouchEnd(e, props.onClick)}
            onTouchMove={(e) => {
              this.onTouchMove(e, !props.isSelected);
            }}
          />

          {props.isSelected && (
            <>
              {/* `transform={false}` — E ISSO CONSERTA UM DEFEITO MEDIDO.

                  O `<Html>` do react-konva aplica a transformacao do PALCO no `<div>` que ele
                  cria, e o palco carrega o ZOOM da folha. Medido em 13/09, com a folha a 91%: os
                  botoes do menu do item, declarados com 44px, chegavam a tela com 40 — 44 x 0,91.
                  A 24% (uma A4 numa janela baixa) seriam 10px.

                  Alvo de toque que encolhe conforme o zoom da folha nao e alvo de toque. E o menu
                  ja se posiciona em COORDENADAS DE TELA (`getItemMenuPos`) num container
                  `position: fixed` — a transformacao do palco por cima disso era escala a mais,
                  nao posicionamento. */}
              <Html
                transform={false}
                // O `<Html>` cria um `<div>` DENTRO do container do palco. Com a transformacao
                // ligada ele o deixa `position: absolute`; com `transform={false}` ele LIMPA o
                // estilo, e o div cai no fluxo normal — ocupando espaco e COBRINDO parte do
                // canvas. Medido: depois de trocar para `transform={false}`, os quadros 2 e 3 da
                // tirinha pararam de selecionar, porque o div comia o clique.
                //
                // Zerado e absoluto, ele volta a nao ocupar nada. O menu em si e `position:
                // fixed` e se posiciona sozinho, entao nao precisa de caixa nenhuma.
                divProps={{
                  style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                  },
                }}
              >
                <ItemMenuContainer
                  ref={itemMenuRef}
                  style={this.getItemMenuPos(itemMenuEl)}
                >
                  {this.getMenuBts(props)}
                </ItemMenuContainer>
              </Html>

              <Transformer
                ref={trRef}
                boundBoxFunc={(oldBox, newBox) =>
                  props.boundBoxFunc(oldBox, newBox, itemMenuRef.current)
                }
                onTransformEnd={props.onTransformEnd}
              />
            </>
          )}
        </>
      );
    };
    return <El />;
  }
}
